export function validateEventDate(eventDetails, eventIdProp) {
  const today = new Date();
  const selectedEvent = eventDetails.data.eventList.find(
    ({ eventId }) => eventId === eventIdProp
  );
  const dateParts = selectedEvent?.eventDate?.split("/");
  const eventDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
  if (today > eventDate) return false;
  return true;
}
